import styled from 'styled-components';
import TituloAreas from './TituloAreas';


const ContainersGeralCards = styled.div`
    
`;

ContainersGeralCards.TituloAreas = TituloAreas;

export default ContainersGeralCards;
